const getModuleState = (state) => state.genres;

export const getAllGenres = (state) => getModuleState(state).allGenres;
export const getGenreById = (state) => getModuleState(state).genreById;
export const getGenreBySlug = (state) => getModuleState(state).genreBySlug;